import LinkPainel from './LinkPainelReducer';

const reducer = LinkPainel;

export default reducer;
